export default "__VITE_ASSET__BnLzSyu5__"